import type { FailureMode } from "../types";

/**
 * Turn a failure mode into a "penalize responses" evaluator criterion (#1399).
 *
 * Failure modes are a discovery feature: they describe what goes *wrong*.
 * Evaluator criteria, by house convention, open with an explicit directive —
 * here "Penalize responses that…" — so we frame the mode directly as the
 * behaviour to penalize, carrying its own label (and fuller description when
 * present) through as the specifics the judge grades against.
 *
 * This only seeds an editable draft: the caller lands the user on the new
 * evaluator's detail page to refine the wording before it does any real grading.
 */
export function penaltyCriteriaForMode(
  mode: Pick<FailureMode, "label" | "description">,
): string {
  // Strip a trailing period off the label so it never doubles up with the one
  // the template adds.
  const label = mode.label.trim().replace(/\.+$/, "").trim();
  const description = mode.description?.trim();
  const base = `Penalize responses that exhibit the following failure mode: ${label}.`;
  return description ? `${base}\n\n${description}` : base;
}
